module.exports = __webpack_public_path__ + "img/sinBarrreras242.ae81346b.jpg";